import { BaseApiResponse } from '@core/swagger-client';
import { ErrorMessage, Loader } from '@core/ui';
import { ReactNode } from 'react';

/**
 * The one loading-and-error convention for every independently-fetched block on this page.
 *
 * Each block is its own request, so each can fail on its own, and silence in either state is
 * indistinguishable from an answer. A failed daily fetch used to render complete-looking headline
 * tiles above a chart that simply returned nothing — on the one page whose stated purpose is
 * validating an invoice, a customer could not tell a quiet quarter from a request that never
 * arrived. A block that returns nothing while loading is the same problem in miniature: it pops
 * in later and, until it does, reads as absent.
 */
export const UsagePanel = ({ isLoading, error, children }: { isLoading: boolean; error?: BaseApiResponse | null; children: ReactNode }) => {
    if (error) return <ErrorMessage apiError={error} classNames="my-4" />;
    if (isLoading) return <Loader />;

    return <>{children}</>;
};
